import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle';
import Avatar from './Avatar/Avatar';
import LanguageSelector from './LanguageSelector';

import { useApplication } from '../AppContext';

const imgStyle = {
	height: '100px',
};

const avatarWrapperStyle = {
	display: 'inline-block',
	margin: '0 0 5px 0',
};

const Profile = () => {

	const { t } = useTranslation();
	const app = useApplication();
	const showPrivacyOptions = app.portal.isPrivacyOptionsRequired();
	const openPrivacyOptions = React.useCallback(() => {
		app.portal.showPrivacyOptions().catch(error => console.log('Privacy options failed', error));
	}, [app]);
	const [name, setName] = React.useState(app?.userdata?.name ?? '');

	const appRef = React.useRef(app);
	const nameRef = React.useRef(name);

	const handleNameChange = React.useCallback((e) => {
		const newName = e.target.value;
		setName(newName);
		nameRef.current = newName;
	}, []);

	const handleAvatarClick = React.useCallback((e) => {
		e?.stopPropagation?.();
		e?.preventDefault?.();
		app.navigate('Avatar');
	}, [app]);

	React.useEffect(() => {
		const app = appRef.current;

		return () => {

			if (app?.userdata && nameRef.current !== app.userdata.name) {
				app.userdata.name = nameRef.current;
				app.save();
			}
		};
	}, []);

	const [showConfirm, setShowConfirm] = React.useState(false);

	const handleResetClick = React.useCallback(() => {
		setShowConfirm(true);
	}, []);

	const handleConfirmReset = React.useCallback(() => {
		setShowConfirm(false);
		app.resetStats();
	}, [app]);

	const handleCancelReset = React.useCallback(() => {
		setShowConfirm(false);
	}, []);

	return (
		<div id="Profile" className="page1 profile">
			<div className="wrapper">
				<PageTitle>
					<h1>{t('Profile')}</h1>
				</PageTitle>
				<div
					className="avatar"
					style={avatarWrapperStyle}
				>
					<label>{t('Avatar')}</label>

					<Avatar
						id="imgAvatar"
						avatar={app?.userdata?.avatar}
						style={imgStyle}
					/>
					<a
						onClick={handleAvatarClick}
						className="simpleButtonOutLine"
					>
						{t('Change')}
					</a>
				</div>
				<div>
					<label>
						{t('Name')}
					</label>
					<input
						placeholder={t('Name')}
						value={name}
						onChange={handleNameChange}
						type="text"
					/>
				</div>
				<div>
					<label>
						{t('Language')}
					</label>
					<LanguageSelector />
				</div>
				<div>
					<label>
						{t('Reset Stats')}
					</label>
					<a className="simpleButtonOutLine " onClick={handleResetClick}>
						{t('Reset')}
					</a>
					{showConfirm && (
						<div className="confirm-dialog">
							<p>{t('Are you sure you want to reset your stats?')}</p>
							<a className="simpleButtonOutLine" onClick={handleConfirmReset}>{t('Yes')}</a>
							<a className="simpleButtonOutLine" onClick={handleCancelReset}>{t('No')}</a>
						</div>
					)}
				</div>
				<div>
					<label>
						{t('Advertisements')}
					</label>
					<button type="button" onClick={() => app.showAd(true)} className="simpleButtonOutLine">
						{t('Show Ad')}
					</button>
				</div>
				{showPrivacyOptions && (
					<div>
						<label>
							{t('Privacy')}
						</label>
						<button type="button" onClick={openPrivacyOptions} className="simpleButtonOutLine">
							{t('Privacy choices')}
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default React.memo(Profile);
